import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import Project from '@/models/Project';
import ProjectRepository from '@/repositories/ProjectRepository';
import ClientRepository from '@/repositories/ClientRepository';
import AutocompleteGroupInput from '@/components/global/AutocompleteGroupInput.vue';
import { BlockClientTransferData } from '@/interfaces/BlockClientTransferData';
import i18n from '@/i18n';

interface PopupData {
  block: boolean;
  clientName: string;
  clientId?: string | null;
  confirmAction?: (reason: string, transferData: BlockClientTransferData | null) => void;
}

interface Props {
  popupData: PopupData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleBlockClientModal',
  props: {
    popupData: null
  },
  setup(__props: any) {

const props = __props as {
  popupData: PopupData;
};



const reason = ref<string>('');
const transferEnabled = ref<boolean>(false);
const projects = ref<Project[]>([]);
const replaceClientId = ref<string | null>(null);
const replaceContactPersonId = ref<string | null>(null);
const currentClientContactPersons = ref<any[]>([]);

const projectNames = computed(() => {
  return projects.value.map((project: Project, index: number) => {
    const connection = project.connection != null ? project.connection : i18n.t('Nema definiranu projekt-vezu');
    return `${i18n.t('Projekt')} ${index + 1}: ${connection}`;
  });
});

const isConfirmDisabled = computed(() => {
  if (props.popupData.block && !reason.value.trim()) {
    return true;
  }
  if (transferEnabled.value && !replaceClientId.value) {
    return true;
  }
  return false;
});

onMounted(async () => {
  if (props.popupData.block && props.popupData.clientId) {
    await Project.getByClient(props.popupData.clientId);
    projects.value = ProjectRepository.filterProjectsByClient(props.popupData.clientId);
  }
});

function onClientSelect(id: string) {
  replaceClientId.value = id;
  replaceContactPersonId.value = null;
  const client = ClientRepository.getById(id);
  if (client) {
    currentClientContactPersons.value = client.contactPersons;
  }
}

function onContactPersonSelect(id: string) {
  replaceContactPersonId.value = id;
}

function onCancel() {
  EventBus.$emit(EventBusEvents.closePopup);
}

function onConfirm() {
  if (!props.popupData.confirmAction) {
    return;
  }
  const transferData: BlockClientTransferData | null =
    transferEnabled.value && replaceClientId.value
      ? {
          projects: projects.value,
          newClientId: replaceClientId.value,
          newContactPersonId: replaceContactPersonId.value,
        }
      : null;
  props.popupData.confirmAction(reason.value, transferData);
}

return { __sfc: true,props, reason, transferEnabled, projects, replaceClientId, replaceContactPersonId, currentClientContactPersons, projectNames, isConfirmDisabled, onClientSelect, onContactPersonSelect, onCancel, onConfirm, AutocompleteGroupInput }
}

})